/**
 * Aikuiset | Lapset size tabs in the size sheet (snippets/variant-picker.liquid).
 *  - a tab click shows that size group;
 *  - on load, when the sheet would open with a kids size preselected (Shopify's first available variant)
 *    and the link did not ask for that variant, the first available adult size is selected instead, so an
 *    adult never adds a kids shoe by accident.
 */
(() => {
  const show = (tabs, group) => {
    const grid = tabs.parentElement && tabs.parentElement.querySelector('[data-size-grouped]');
    if (!grid) return;
    grid.setAttribute('data-size-show', group);
    tabs.querySelectorAll('[data-size-tab]').forEach((t) => t.setAttribute('aria-selected', String(t.dataset.sizeTab === group)));
  };

  document.addEventListener('click', (e) => {
    const tab = e.target instanceof Element ? e.target.closest('[data-size-tab]') : null;
    if (!tab) return;
    e.preventDefault();
    show(tab.closest('[data-size-tabs]'), tab.dataset.sizeTab);
  });

  const init = () => {
    if (new URLSearchParams(location.search).has('variant')) return;
    document.querySelectorAll('[data-size-grouped]').forEach((grid) => {
      const checked = grid.querySelector('input[type="radio"]:checked');
      if (!checked || !checked.closest('[data-size-group="kids"]')) return;
      /* Sold-out sizes are marked on the label (.is-disabled), not on the radio. */
      const adult = [...grid.querySelectorAll('[data-size-group="adult"] input[type="radio"]:not(:disabled)')]
        .find((input) => {
          const label = grid.querySelector('label[for="' + CSS.escape(input.id) + '"]') || input.nextElementSibling;
          return !(label && label.classList.contains('is-disabled'));
        });
      if (!adult) return;
      adult.checked = true;
      adult.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
